module.exports = __webpack_public_path__ + "img/leftArrow.d8f545ea.svg";